const flash = document.querySelector(".ui-flash_message");

document.body.addEventListener("showFlash", (e) => {
  const flashKeys = ["notice", "alert"];
  const messages = flashKeys.map((key) => {
    if (!(key in e.detail)) return "";
    const rawValue = e.detail[key] == null ? "" : String(e.detail[key]);
    const decodedMessage = decodeURIComponent(rawValue.replace(/\+/g, " "));
    return `
      <div class="item ${key}">
      <div class="message">${decodedMessage}</div>
      <div class="close"><i class="fa-regular fa-circle-xmark"></i></div>
      </div>
    `;
  });

  flash.innerHTML = messages.join("");
});

if (flash) {
  flash.addEventListener("click", (e) => {
    const closeButton = e.target.closest(".close");
    if (closeButton) {
      const item = closeButton.closest(".item");

      item.classList.add("fadeout");
      item.addEventListener("animationend", () => {
        item.remove();
      });
    }
  });
}
